import React from 'react';
import InstanceItem from './InstanceItem';

const InstanceList = ({ instances, loading, onStart, onStop, pollingInstances = [] }) => {
  if (loading && instances.length === 0) {
    return (
      <div className="flex justify-center items-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (instances.length === 0) {
    return (
      <div className="bg-white shadow-md rounded-lg p-6 text-center">
        <p className="text-gray-600">No instances found.</p>
      </div>
    );
  }

  // Helper function to check if an instance is being polled
  const getPollingStatus = (instanceId, accountId) => {
    const pollingInstance = pollingInstances.find(
      item => item.id === instanceId && item.accountId === accountId
    );
    return pollingInstance ? pollingInstance.targetState : null;
  };

  // For mobile, use a card-based layout
  return (
    <div>
      {/* Desktop view - Table */}
      <div className="hidden md:block bg-white shadow-md rounded-lg overflow-hidden">
        <div className="grid grid-cols-12 bg-gray-100 p-4 font-semibold text-gray-700">
          <div className="col-span-2">Name</div>
          <div className="col-span-2">Instance ID</div>
          <div className="col-span-1">Type</div>
          <div className="col-span-1">State</div>
          <div className="col-span-1">Account</div>
          <div className="col-span-2">Public IP</div>
          <div className="col-span-3">Actions</div>
        </div>
        
        <div className="divide-y divide-gray-200">
          {instances.map(instance => (
            <InstanceItem 
              key={instance.id} 
              instance={instance} 
              onStart={onStart} 
              onStop={onStop} 
              loading={loading}
              view="desktop"
              pollingStatus={getPollingStatus(instance.id, instance.accountId)}
            />
          ))}
        </div>
      </div>

      {/* Mobile view - Cards */}
      <div className="md:hidden space-y-4">
        {instances.map(instance => (
          <div key={instance.id} className="bg-white shadow-md rounded-lg p-4">
            <InstanceItem 
              instance={instance} 
              onStart={onStart} 
              onStop={onStop} 
              loading={loading}
              view="mobile"
              pollingStatus={getPollingStatus(instance.id, instance.accountId)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default InstanceList; 